import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';

type TInitialValuesEmployees = {
  divisionId: string;
  search: string;
  personnelNumber: string;
};

const initialState: TInitialValuesEmployees = {
  divisionId: '',
  search: '',
  personnelNumber: '',
};

export const employeesSlice = createSlice({
  name: 'ui/controls/employees',
  initialState,
  reducers: {
    divisionId(state, { payload }: PayloadAction<string>) {
      return { ...state, divisionId: payload };
    },
    search(state, { payload }: PayloadAction<string>) {
      return { ...state, search: payload };
    },
    personnelNumber(state, { payload }: PayloadAction<string>) {
      return { ...state, personnelNumber: payload };
    },
  },
});

const selectEmployees = (state: RootState) => state.ui.employees;

export const selectors = { selectEmployees };
export const actions = employeesSlice.actions;
export const reducer = employeesSlice.reducer;
